import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import type { GetServerSideProps, NextPage } from 'next';
import styles from './styles.module.scss';

import { PageLayout } from '@/components/pagelay';
import axios from 'axios';
import cName from 'classnames';
import { useRouter } from 'next/router';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Notification } from '@douyinfe/semi-ui';
import Head from 'next/head';
import { PRODDOMAIN, PRODFORNTDOMAIN } from '@/utils';
import { useDate } from '@/utils/useDate';
import { useTranslations } from 'next-intl';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const showdown = require('showdown');

interface IProps {

}


export const getServerSideProps: GetServerSideProps = async context => {
  const { newsId } = context.query;
  const lang = context.locale as any

  const { data } = await axios.get(`${PRODDOMAIN}/getNews?id=${newsId}`, {
    headers: {
      lang
    }
  });
  console.log(data);


  return {
    props: { data: data.data, newsId },
  };
};

export default ({ data, newsId }: any) => {
  const converter = new showdown.Converter();
  const t = useTranslations();
  const router = useRouter()
  console.log(data);

  return (
    <div>
      <PageLayout
        crumb={[
          { path: `${router.locale === 'en' ? '/en' : ''}/media/news_detail/${newsId}`, name: data?.title },
        ]}
        temp='page_crumb'
        partPath={data.category_id === 1 ? `/media/news` : `/media/industry`}
      >
        <div className={styles.container}>
          <Head>
            <title>{data?.meta_title || 'IPB国际粉体、散料、流体加工展览会'} </title>
            <meta name="keywords" content={data?.meta_kws || 'IPB国际粉体、散料、流体加工展览会'} />
            <meta name="description" content={data?.meta_desc || 'IPB国际粉体、散料、流体加工展览会'} />
          </Head>
          <i className={styles.bg1}></i>
          <div>
            <div className={styles.left}>
              <h2>{data?.title}</h2>
              <div className={styles.share}>
                <span>
                  {
                    data?.publish_time ?
                      Object.values(useDate(data?.publish_time))
                        .join('-')
                      : ''
                  }
                </span>
                <div>
                  <CopyToClipboard text={`${PRODFORNTDOMAIN}${router.locale === 'en' ? '/en' : ''}/media/news_detail/${newsId}`}
                    onCopy={() => {
                      Notification.success({
                        content: t('common.tips.copy'),
                        duration: 3,
                      })
                    }}
                  >
                    <div className={styles.wx}>{t('common.share')}</div>
                  </CopyToClipboard>
                </div>
              </div>
              <div
                dangerouslySetInnerHTML={{ __html: converter.makeHtml(data?.content) }}
                className={styles.content} />
              <div className={styles.footer}>
                <div className={styles.links}>
                  {
                    data?.last_news &&
                    <a href={data?.last_news?.url
                      ? data?.last_news?.url
                      : `${router.locale === 'en' ? '/en' : ''}/media/news_detail/${data?.last_news?.id}`}>
                      <span>{t('news.prev')}：{data?.last_news?.info_title}</span>
                    </a>
                  }
                  {
                    data?.next_news &&
                    <a href={data?.next_news?.url
                      ? data?.next_news?.url
                      : `${router.locale === 'en' ? '/en' : ''}/media/news_detail/${data?.next_news?.id}`}>
                      <span>{t('news.next')}：{data?.next_news?.info_title}</span>
                    </a>
                  }
                </div>
                <a
                  style={{ gap: router.locale === 'cn' ? '60px' : '30px' }}
                  href={data.category_id === 1 ? `${router.locale === 'en' ? '/en' : ''}/media/news` : `${router.locale === 'en' ? '/en' : ''} /media/industry`}
                >
                  <span>{t('news.return')}</span>
                  <i></i>
                </a>
              </div>
            </div>
            <div className={styles.right}>
              <p>{t('news.recomm')}</p>
              <ul>
                <li>
                  {
                    data?.recommend_news_list?.map((item: any) => (
                      <a href={item.url ? item.url : `${router.locale === 'en' ? '/en' : ''}/media/news_detail/${item.id}`} target='_blank'>
                        <div className={styles.imgBox}>
                          <img onError={(e: any) => e.target.src = 'http://admin.ipbexpo.com/uploads/editor/20250421/1d158468348e36f262393b6ff2b0d00e.jpg'} src={item.show_image} loading='lazy' alt="" />
                        </div>
                        <div className={styles.info}>
                          <p className={styles.title}>{item.info_title}</p>
                          <p>
                            {
                              item?.publish_time ?
                                Object.values(useDate(item?.publish_time))
                                  .join('-')
                                : ''
                            }
                          </p>
                        </div>
                      </a>
                    ))
                  }
                </li>
              </ul>
            </div>
          </div>
          <style jsx global>
            {
              `
              .semi-typography{
                max-width:600px !important;
              }
              `
            }
          </style>
        </div>
      </PageLayout >
    </div >
  );
};